// extracted by mini-css-extract-plugin
export default {"operationTypeIconLabel":"operationTypeIcon_operationTypeIconLabel__xqXoW"};